import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import { products, categories } from '../data/products';
import './Shop.css';

const sortOptions = [
  { value: 'default', label: 'Featured' },
  { value: 'price-asc', label: 'Price: Low to High' },
  { value: 'price-desc', label: 'Price: High to Low' },
  { value: 'name', label: 'Name A–Z' },
];

export default function Shop() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeCategory, setActiveCategory] = useState(searchParams.get('cat') || 'All');
  const [sort, setSort] = useState('default');
  const [filterOpen, setFilterOpen] = useState(false);

  useEffect(() => {
    const cat = searchParams.get('cat');
    if (cat && categories.includes(cat)) setActiveCategory(cat);
  }, [searchParams]);

  const handleCategory = (cat) => {
    setActiveCategory(cat);
    if (cat === 'All') setSearchParams({});
    else setSearchParams({ cat });
  };

  let filtered = activeCategory === 'All' ? products : products.filter(p => p.category === activeCategory);

  switch (sort) {
    case 'price-asc': filtered = [...filtered].sort((a, b) => a.price - b.price); break;
    case 'price-desc': filtered = [...filtered].sort((a, b) => b.price - a.price); break;
    case 'name': filtered = [...filtered].sort((a, b) => a.name.localeCompare(b.name)); break;
    default: break;
  }

  return (
    <main className="shop-page page-enter">
      <div className="shop-hero">
        <div className="shop-hero-inner">
          <p className="shop-eyebrow">The Collection</p>
          <h1 className="shop-title">All Pieces</h1>
        </div>
      </div>

      <div className="shop-layout">
        {/* Filters sidebar */}
        <aside className={`filters-sidebar ${filterOpen ? 'open' : ''}`}>
          <div className="filters-header">
            <h3 className="filters-title">Filter</h3>
            <button className="filters-close" onClick={() => setFilterOpen(false)}>×</button>
          </div>
          <div className="filter-group">
            <h4 className="filter-group-title">Category</h4>
            {categories.map(cat => (
              <button
                key={cat}
                className={`filter-btn ${activeCategory === cat ? 'active' : ''}`}
                onClick={() => { handleCategory(cat); setFilterOpen(false); }}
              >
                {cat}
                {activeCategory === cat && <span className="filter-check">✓</span>}
              </button>
            ))}
          </div>
        </aside>

        <div className="shop-main">
          <div className="shop-toolbar">
            <button className="mobile-filter-btn" onClick={() => setFilterOpen(true)}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                <line x1="4" y1="6" x2="20" y2="6"/><line x1="8" y1="12" x2="16" y2="12"/><line x1="12" y1="18" x2="12" y2="18"/>
              </svg>
              Filter
            </button>
            <p className="results-count">{filtered.length} piece{filtered.length !== 1 ? 's' : ''}</p>
            <div className="sort-wrap">
              <label className="sort-label">Sort:</label>
              <select className="sort-select" value={sort} onChange={e => setSort(e.target.value)}>
                {sortOptions.map(o => (
                  <option key={o.value} value={o.value}>{o.label}</option>
                ))}
              </select>
            </div>
          </div>

          {/* Desktop category pills */}
          <div className="category-pills">
            {categories.map(cat => (
              <button
                key={cat}
                className={`pill ${activeCategory === cat ? 'active' : ''}`}
                onClick={() => handleCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          <div className="products-grid">
            {filtered.map(p => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>

          {filtered.length === 0 && (
            <div className="no-results">
              <p>No pieces found in this category.</p>
              <button className="pill active" onClick={() => handleCategory('All')}>View All</button>
            </div>
          )}
        </div>
      </div>

      {filterOpen && <div className="filters-overlay" onClick={() => setFilterOpen(false)} />}
    </main>
  );
}
